import React, { useState, useEffect, useCallback, memo } from "react";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Config } from "../../../../Utils/Config";
import {knownDevTabDetails} from "../../../../Utils/common";
import excelicon from "../../../../Assets/Images/excel-icon.png";
import moment from "moment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import classnames from 'classnames';
import Transaction from "./Transaction";
import "./KnownDevelopments.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  Accordion, AccordionDetails, AccordionSummary, Paper, IconButton, Tooltip, Snackbar, Checkbox, FormControlLabel
} from '@mui/material';
import { SpanMessage } from "../../../../helpers/componentHelper";
import { isS3Url } from "../../../../helpers/dataHelper";
import { apiCommonTrigger, apiCommonTriggerBlob } from "../../../../Utils/apiServicehelper";
const apiPath = process.env.REACT_APP_API_URL;
const KnownDevelopments = memo((props, match, marketDetails, marketProps, history) => {
  const location = useLocation();
  const navigate = useNavigate();
  const marketId = props?.marketId || location.pathname.split("/").pop();
  const [state, setState] = useState({
      MarketID: marketId || 0,
      isLoading: false,
      knowndatamap: "",
      activeTab: "1",
      mapDetails: marketDetails||{},
      order: "asc",
      snackClr: "",
      snackOpen: false,
      snackMsg: "",
      ShowKnowDev: false,
      knwDevData: {},
      updateDataKD: [],
      knownDevTabs: [],
      existingId: 1,
      disablePdf: false,
      avoidPdfMultipleCliks: true,
      avoidExcelMultipleCliks: true,
      activeTabCount: '1',
      countryName: marketDetails?.country,
      docLoader: false,
      supplyApi: false,
      verifyChecked: true,
      unVerifyChecked: false,
      openMissingpropOpen: false,
  });
  const [dataLoader , setDataLoader] = useState(false);

  const accordionChange = (id) => {

    let data = state.knownDevTabs.map((d) => {
      if (d.id === id) {
        // Toggle open/close if it's the same id, or set it open for a new id
        d.isOpen = state.existingId === id ? !d.isOpen : true;
      } else {
        // Close all other tabs
        d.isOpen = false;
      }
      return d;
    });  
    // Set new state with the updated data
    setState({...state, knownDevTabs: data,existingId: id});
  };
  

  const handleVerifyCheck = (event) => {
      const { name, checked } = event.target;
      let filterPinfoData;

      if (name === 'verifyChecked' && !checked && state.unVerifyChecked) {
          filterPinfoData = state.knowndatamap.pInfo.filter(item => item.verifiedstatus === "Unverified");
      } else if ((name === 'verifyChecked' || name === 'unVerifyChecked') && checked && (state.unVerifyChecked || state.verifyChecked)) {
          filterPinfoData = state.knowndatamap.pInfo;
      } else if ((name === 'verifyChecked' || name === 'unVerifyChecked') && !checked && (!state.unVerifyChecked || !state.verifyChecked)) {
          filterPinfoData = [];
      } else if (name === 'unVerifyChecked' && !checked && state.verifyChecked) {
          filterPinfoData = state.knowndatamap.pInfo.filter(item => item.verifiedstatus === "Verified");
      } else if (name === 'verifyChecked' && checked && !state.unVerifyChecked) {
          filterPinfoData = state.knowndatamap.pInfo.filter(item => item.verifiedstatus === "Verified");
      } else if (name === 'unVerifyChecked' && checked && !state.verifyChecked) {
          filterPinfoData = state.knowndatamap.pInfo.filter(item => item.verifiedstatus === "Unverified");
      }

      setState(prevState => ({
          ...prevState,
          updateDataKD: {
              ...prevState.updateDataKD,
              pInfo: filterPinfoData
          },
          [name]: checked
      }));
  };

  const snackHandleClose = () => setState(prev => ({ ...prev, snackOpen: false }));

  const reOrder = () => {
    let data = knownDevTabDetails;
    data.forEach((d) => {
      if (d.id === 1) {
        d.isOpen = true;
      } else {
        d.isOpen = false;
      }
    });
    setState(prev => ({ ...prev, knownDevTabs: data }));
    setDataLoader(false)
  };

  useEffect(() => {
      const fetchInitialData = async () => {
        setDataLoader(true)
        const res = await apiCommonTrigger("get" , Config.API_URL + "/KnownDev/" , [state.MarketID])
          .then((res) => {
            if (res.status === 200) {
              setState(prevState => ({
                ...prevState,
                knowndatamap: res.data,
                updateDataKD: res.data,
                isLoading: false
            }));
            reOrder();
            } else {
              setState(prevState => ({ ...prevState, isLoading: false }));
              handlingCatchError(res, navigate);
            }
          })
          .catch((err) => {
            setState(prevState => ({ ...prevState, isLoading: false }));
            handlingCatchError(err, navigate);
          });
      };

      fetchInitialData();
  }, [state.MarketID]);

  const NumberFormat = (number) => {
    return new Intl.NumberFormat().format(number);
  }

const displayPropertyDetail = (id) => {
    const {  verifyChecked, unVerifyChecked } = state;

  // Apply filtering based on checkbox states
    let filteredPInfo;
    if (verifyChecked && !unVerifyChecked) {
        filteredPInfo = state.updateDataKD.pInfo.filter(item => item.verifiedstatus === "Verified");
    } else if (!verifyChecked && unVerifyChecked) {
        filteredPInfo = state.updateDataKD.pInfo.filter(item => item.verifiedstatus === "Unverified");
    } else if (verifyChecked && unVerifyChecked) {
        filteredPInfo = state.updateDataKD.pInfo;
    } else {
        filteredPInfo = [];
    }
    const filteredStoreIds = filteredPInfo.map(item => item.facilityid);
     // Filter other attributes based on the filtered storeIds
     let filteredCInfo = state.updateDataKD.cInfo ? state.updateDataKD.cInfo.filter(item => filteredStoreIds.includes(item.facilityid)) : [];
     let filteredDCenter = state.updateDataKD.dCenter ? state.updateDataKD.dCenter.filter(item => filteredStoreIds.includes(item.facilityid)) : [];
     let filteredOInfo = state.updateDataKD.oInfo ? state.updateDataKD.oInfo.filter(item => filteredStoreIds.includes(item.facilityid)) : [];
     let filteredOPInfo = state.updateDataKD.opInfo ? state.updateDataKD.opInfo.filter(item => filteredStoreIds.includes(item.facilityid)) : [];

  let data =
  id === 1
    ? filteredPInfo
    : id === 2
      ? filteredOInfo
      : id === 3
        ? filteredCInfo
        : id === 4
          ? filteredOPInfo
          : id === 5
            ? filteredDCenter
            : null;

    let dupList = [];
    if (id === 5) {
      dupList = data
        .filter((x) =>x.filename !== "")
        .map((y) => y.documenttype);
      if (dupList.length > 0)
        dupList = dupList.filter((x, i, a) => a.indexOf(x) === i);
    }

    let list = [];
    list.push(
      <React.Fragment>
        {data && data.length > 0 ? (
          <tr>
            <th className="headcol" style={{ backgroundColor: "#3f703b" }}></th>
            {filteredPInfo && filteredPInfo.length > 0
              ? filteredPInfo.map((result, index) => (
                <th className="long main-head">
                  {result.facilityname ? (
                    <h4> {result.facilityname}</h4>
                  ) : (
                    <h4></h4>
                  )}
                  <p>{result.address ? result.address.replace(/^,+|,+$/g, '') : "--"}</p>
                </th>
              ))
              : ""}
          </tr>
        ) : (
          <div className="kd-no-data no-data">No Data Available</div>
        )}
        {id === 1 ? (
          <React.Fragment>
            {data.filter(
              (x) =>
                x.stage !== "" ||
                x.projecttype !== "" ||
                x.facilityname !== "" ||
                x.address !== "" ||
                x.county !== "" ||
                x.facilitytype !== "" ||
                x.propertyurl !== "" ||
                x.zoning !== "" ||
                x.zoningdescription !== "" ||
                x.summary !== "" ||
                x.acres !== null ||
                x.propertybuildingpermit !== "" ||
                x.propertybuildingparcel !== "" ||
                x.buildingsqft !== null ||
                x.estimatedrentablesquarefootage !== null ||
                x.parkingestimatedrentablesquarefootage !== null ||
                x.parkingbuildingsquarefootage !== null ||
                (x.isestimatedselfstoragesqft !== false && x.isestimatedselfstoragesqft !== null) ||
                (x.isestimatedparkingsqft !== false && x.isestimatedparkingsqft !== null) ||
                x.noofbuildings !== null ||
                x.selfstorageunits!== null ||
                x.parkingunits!== null ||
                x.floors !== null ||
                x.noofunits !== null ||
                x.estimatevalue !== null ||
                x.permithistorylog !== "" ||
                x.permitmonth !== "" ||
                x.salesstatus !== "" ||
                x.salespricing !== "" ||
                x.expectedopendate !== null ||
                x.verifiedstatus !== "" ||               
                x.citycountyofficephone !== "" ||
                x.citycountytollfree !== ""
            ).length > 0 ? (
              <React.Fragment>
                {data.filter((x) => x.stage !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Stage</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.stage ? result.stage : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.projecttype !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Project Type</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.projecttype ? result.projecttype : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.storeName !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Facility Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.facilityname ? result.facilityname : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.address !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Address</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.address ? result.address.replace(/^,+|,+$/g, '') : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.county !== "" && x.county !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">County</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.county ? result.county : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.facilitytype !== "" && x.facilitytype !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">Facility Type</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.facilitytype ? result.facilitytype : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.propertyurl !== "" && x.propertyurl !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">Property URL</th>
                    {data.map((result, index) => {
                      let propertyurl = result.propertyurl
                        ? result.propertyurl
                          .toString()
                          .replace(/&amp;/gi, "&")
                          .split("; ")
                          .map((data) => {
                            try {
                              let domain = new URL(data);
                              const segment_array = data;
                              const last_segment = segment_array.slice(
                                segment_array.length - 15
                              );
                              return (
                                <>
                                  <a target="_blank" href={data} title={data} rel="noreferrer">
                                  {domain.origin}/.....{last_segment}
                                  </a>
                                </>
                              );
                            }
                            catch (error) { }
                          })
                        : "-";
                      return <td className="long">{propertyurl}</td>;
                    })}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.zoning !== "" && x.zoning !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">Zoning</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.zoning ? result.zoning : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.summary !== "" && x.summary !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">Development Project Summary</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.summary ? result.summary : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.acres !== "" && x.acres !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Acres</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.acres ? result.acres : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.propertybuildingpermit !== "" && x.propertybuildingpermit !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Property Building Permit</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.propertybuildingpermit ? result.propertybuildingpermit : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.propertybuildingparcel !== "" && x.propertybuildingparcel !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Property Building Parcel</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.propertybuildingparcel ? result.propertybuildingparcel : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                
                {data.filter(
                  (x) => x.noofbuildings !== "" && x.noofbuildings !== null
                ).length > 0 ? (
                  <tr>
                    <th className="headcol">Number Of Buildings</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.noofbuildings ? result.noofbuildings : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.estimatevalue).length > 0 ? (
                  <tr>
                    <th className="headcol">Estimated Value</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.estimatevalue
                          ? Config.Currency +
                          NumberFormat(result.estimatevalue)
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.permithistorylog !== "" && x.permithistorylog !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Permit History Log</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.permithistorylog ? result.permithistorylog : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.permitmonth !== "" && x.permitmonth !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Permit Month</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.permitmonth ? result.permitmonth : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.salesstatus !== "" && x.salesstatus !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Sales Status</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.salesstatus ? result.salesstatus : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.salespricing !== "" && x.salespricing !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">Sales Pricing</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.salespricing
                          ? Config.Currency +
                          NumberFormat(result.salespricing)
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter(
                  (x) =>
                    x.expectedopendate !== "" && x.expectedopendate !== null
                ).length > 0 ? (
                  <tr>
                    <th className="headcol">Expected Open Date</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.expectedopendate
                          ? moment(result.expectedopendate).format(
                            "DD-MMM-YYYY"
                          )
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                 {data.filter(
                  (x) =>
                    x.verifiedstatus !== "" && x.verifiedstatus !== null
                ).length > 0 ? (
                  <tr>
                    <th className="headcol">Project Verification Status</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.verifiedstatus
                          ? result.verifiedstatus
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.sourceurl !== "" && x.sourceurl !== null)
                  .length > 0 ? (
                  <tr>
                    <th className="headcol">Source URL</th>
                    {data.map((result, index) => {
                      let sourceurl = result.sourceurl
                        ? result.sourceurl
                          .toString()
                          .replace(/&amp;/gi, "&")
                          .split("; ")
                          .map((data, urlCount, totLength) => {
                            try {
                              let domain = new URL(data);
                              const segment_array = data;
                              const last_segment = segment_array.slice(
                                segment_array.length - 15
                              );
                              return (
                                <>
                                  <a target="_blank" href={data} title={data} rel="noreferrer">
                                    Source URL{" "}
                                    {totLength.length === 1 ? "" : urlCount + 1}
                                  </a>
                                  &nbsp; ({domain.origin}/.....{last_segment})
                                  <br />
                                </>
                              );
                            }
                            catch (error) { }
                          })
                        : "-";
                      return <td className="long">{sourceurl}</td>;
                    })}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.citycountyofficephone !== "" && x.citycountyofficephone !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">City/County Office Phone</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.citycountyofficephone ? result.citycountyofficephone : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.citycountytollfree !== "" && x.citycountytollfree !== null).length >
                  0 ? (
                  <tr>
                    <th className="headcol">City/County TollFree</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.citycountytollfree ? result.citycountytollfree : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter(
                  (x) => x.lastcheckeddate !== "" && x.lastcheckeddate !== null
                ).length > 0 ? (
                  <tr>
                    <th className="headcol">Last Checked Date</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.lastcheckeddate
                          ? moment(result.lastcheckeddate).format("DD-MMM-YYYY")
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <tr>
                <th className="headcol no-data">No Data Available</th>
                <td
                  colSpan={
                    state.updateDataKD && state.updateDataKD.pInfo
                      ? state.updateDataKD.pInfo.length
                      : null
                  }
                >
                  &nbsp;
                </td>
              </tr>
            )}
          </React.Fragment>
        ) : id === 2 ? (
          <React.Fragment>
            {data.filter(
              (x) =>
                x.ownername !== "" ||
                x.owneraddress !== "" ||
                x.ownerphone !== "" ||
                x.ownercontactname !== "" ||
                x.owneremail !== ""
            ).length > 0 ? (
              <React.Fragment>
                {data.filter((x) => x.ownername !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Owner Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.ownername ? result.ownername : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.owneraddress !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Owner Address</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.owneraddress ? result.owneraddress : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.ownerphone !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Owner Phone</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.ownerphone ? result.ownerphone : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.ownercontactname !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Owner Contact Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.ownercontactname
                          ? result.ownercontactname
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.owneremail !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Owner Email</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.owneremail ? result.owneremail : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <tr>
                <th className="headcol no-data">No Data Available</th>
                <td
                  colSpan={
                    state.updateDataKD && state.updateDataKD.pInfo
                      ? state.updateDataKD.pInfo.length
                      : null
                  }
                >
                  &nbsp;
                </td>
              </tr>
            )}
          </React.Fragment>
        ) : id === 3 ? (
          <React.Fragment>
            {data.filter(
              (x) =>
                x.contractorname !== "" ||
                x.contractoraddress !== "" ||
                x.contractorphone !== "" ||
                x.contractorcontactname !== "" ||
                x.contractoremail !== ""
            ).length > 0 ? (
              <React.Fragment>
                {data.filter((x) => x.contractorname !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Contractor Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.contractorname ? result.contractorname : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.contractoraddress !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Contractor Address</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.contractoraddress
                          ? result.contractoraddress
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.contractorphone !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Contractor Phone</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.contractorphone ? result.contractorphone : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.contractorcontactname !== "").length >
                  0 ? (
                  <tr>
                    <th className="headcol">Contractor Contact Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.contractorcontactname
                          ? result.contractorcontactname
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.contractoremail !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Contractor Email</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.contractoremail ? result.contractoremail : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <tr>
                <th className="headcol no-data">No Data Available</th>
                <td colSpan="">&nbsp;</td>
              </tr>
            )}
          </React.Fragment>
        ): id === 4 ? (
          <React.Fragment>
            {data.filter(
              (x) =>
                x.operator !== "" ||
                x.operatortype !== ""
            ).length > 0 ? (
              <React.Fragment>                
                {data.filter((x) => x.operator !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Operator/Management Company Name</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.operator ? result.operator : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
                {data.filter((x) => x.operatortype !== "").length > 0 ? (
                  <tr>
                    <th className="headcol">Operator Type</th>
                    {data.map((result, index) => (
                      <td className="long">
                        {result.operatortype ? result.operatortype : "-"}
                      </td>
                    ))}
                  </tr>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <tr>
                <th className="headcol no-data">No Data Available</th>
                <td
                  colSpan={
                    state.updateDataKD && state.updateDataKD.pInfo
                      ? state.updateDataKD.pInfo.length
                      : null
                  }
                >
                  &nbsp;
                </td>
              </tr>
            )}
          </React.Fragment>
        ) : id === 5 ? (
          <React.Fragment>
            {dupList && dupList.length > 0 ? (
              dupList.map((datum) => {
                return (
                  <tr>
                    <th className="headcol">{datum}</th>
                    {data
                      .map((result) => (
                        <td className="long">
                          {result.filename && result.documenttype === datum ? (
                            <span
                              onClick={() =>
                                downloadDocumentCenter(
                                  result.facilityid,
                                  result.documenttypeid,
                                  result.documenttype,
                                  result
                                )
                              }
                              className="d-center-download-link"
                            >
                              Click to view and download{" "}
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                      ))}
                  </tr>
                );
              })
            ) : ( <tr>
              <th className="headcol"></th>
                <td className="text-center no-data" colSpan={filteredPInfo?.length}>
                No Data Available
                </td>
            </tr>
            )}
          </React.Fragment>
        ) : (
          ""
        )}
      </React.Fragment>
    );
    return list; 
  };

  const exportCompExcel = () => {
    let timestamp = new Date().getDate() + "" + new Date().getMonth() + "" +
      new Date().getFullYear() + "" + new Date().getTime();
   
      let MarketID = state.MarketID
      var fileName =MarketID + "_Developments_" + timestamp + ".xlsx";
     apiCommonTriggerBlob("get",`${Config.API_URL}/KnownDev/excel/`, [MarketID])
        .then((res) => {
          let link = document.createElement('a');
          const isSuccess = res.status === 200;
          const isUnauthorized = res.status === 401;
      
          if (isSuccess) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            // For Firefox, delay revoking the ObjectURL
            setTimeout(() => {
              window.URL.revokeObjectURL(link.href);
              link.remove();
            }, 3000);
          } else if (isUnauthorized) {
            navigate("/");
            return; // Exit early if unauthorized
          }else{
            handlingCatchError(res, navigate);
          }   
        })
        .catch((error) => {
          handlingCatchError(error, navigate);
        });
  }

  const exportCompPDF = () => {
    setState(prevState => ({ 
      ...prevState, 
      disablePdf: true,  
      avoidPdfMultipleCliks: false
    }));
    const marketId = state?.MarketID || 0;
    //construct time stamp for pdf report filenmae
    var timestamp =
      new Date().getDate() +
      "" +
      new Date().getMonth() +
      "" +
      new Date().getFullYear() +
      "" +
      new Date().getTime();
    //construct filename for pdf report.
    var fileName =
    marketId +
      "_Developments_" +
      timestamp +
      ".pdf";
    setState(prevState => ({ 
      ...prevState, 
      snackOpen: true,  
      snackMsg: "Your download is being processed. The " + fileName + " file will download automatically to your browser when ready. Please do not close or refresh the window until the download is complete. We recommend you check your Downloads folder if you don’t see it in your browser.",
      snackClr: "snack-success",
    }));

    let inputData = {
      marketid: marketId?parseInt(marketId):0,
      filename: fileName
    };
     apiCommonTriggerBlob("post",`${Config.API_URL}/KnownDev/report/development`, inputData)
    .then((res) => {
      let link = document.createElement('a');
      const isSuccess = res.status === 200;
      const isUnauthorized = res.status === 401;
  
      if (isSuccess) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        // For Firefox, delay revoking the ObjectURL
        setTimeout(() => {
          window.URL.revokeObjectURL(link.href);
          link.remove();
        }, 3000);
      } else if (isUnauthorized) {
        navigate("/");
        return; // Exit early if unauthorized
      }
  
      setState(prevState => ({
        ...prevState,
        disablePdf: false,
        isLoading: false,
        avoidPdfMultipleCliks: true
      }));
    })
    .catch((error) => {
      setState(prevState => ({
        ...prevState,
        isLoading: false,
        avoidPdfMultipleCliks: true,
        disablePdf: false
      }));
      handlingCatchError(error, navigate);
    });
  
  };

  const downloadDocumentCenter = (facilityid, docTypeId, name ,result) => {
    const isS3UrlBool = isS3Url(result.filename);

    if(!isS3UrlBool && result.filename){
      window.open(result.filename, "_blank");
      return true;
    }
    setState(prevState => ({ ...prevState, docLoader: true }));
    let date = new Date();
    let monthCal = date.getMonth() + 1;
    let dateFormat = date.getFullYear() + "-" + monthCal + "-" + date.getDate();
    var fileName = name + "_" + dateFormat+'.pdf';
      const inputType = {
        facilityid : facilityid, 
        doctypeid: docTypeId, 
        doccentertypeid : 1
      }
      apiCommonTriggerBlob("post",`${Config.API_URL}/knowndev/documentcenter`, inputType)
        .then((res) => {
          let link = document.createElement('a');
          const isSuccess = res.status === 200;
          const isUnauthorized = res.status === 401;
      
          if (isSuccess) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            // For Firefox, delay revoking the ObjectURL
            setTimeout(() => {
              window.URL.revokeObjectURL(link.href);
              link.remove();
            }, 3000);
          } else if (isUnauthorized) {
            navigate("/");
            return; // Exit early if unauthorized
          }else{
            handlingCatchError(res, navigate);
          }   

          setState(prevState => ({ ...prevState, isLoading: false, docLoader: false }));
        })
      .catch((err) => {
        setState(prevState => ({ ...prevState, isLoading: false, docLoader: false }));
        handlingCatchError(err, navigate);
      });
  };


  const isDataAvailable = state.updateDataKD && 
  state.updateDataKD.oInfo && state.updateDataKD.oInfo.length > 0  && 
  state.updateDataKD.cInfo && state.updateDataKD.cInfo.length > 0  && 
  state.updateDataKD.opInfo && state.updateDataKD.opInfo.length > 0 &&
  state.updateDataKD.dCenter && state.updateDataKD.dCenter.length > 0;

  return (
      <div>
          {state.isLoading || state.docLoader || dataLoader ? (
            <div className="loader-wrap">
              <div className="loading loading-center"></div>
            </div>
          ) : (
            ""
          )}

          {/* {state.openMissingpropOpen && (
              <MissingPropFormModal
                  isOpen={state.openMissingpropOpen}
                  handleClose={() => setState(prev => ({ ...prev, openMissingpropOpen: false }))}
              />
          )} */}

          <div className="mt-3 is-it-store">
              <Col md="12" className="pt-3 dashboard-layout last-months compover-tab-format">
                  <Row>
                      <Col md="12">
                          <div className="comp-overlist">
                              <Nav tabs>
                                  <NavItem>
                                      <NavLink
                                          className={classnames({ active: state.activeTabCount === '1' })}
                                          onClick={() => setState(prev => ({ ...prev, activeTabCount: '1' }))}
                                      >
                                          Developments {Number(props.data?.knowndevelopmentscount) ? <span className="count-dev">{props.data.knowndevelopmentscount}</span> : ""}
                                      </NavLink>
                                  </NavItem>
                                      <NavItem>
                                          <NavLink
                                              className={classnames({ active: state.activeTabCount === '2' })}
                                              onClick={() => setState(prev => ({ ...prev, activeTabCount: '2' }))}
                                          >
                                              Transactions {Number(props.data?.sourcetransactioncount) ? <span className="count-dev">{props.data.sourcetransactioncount}</span> : ""}
                                          </NavLink>
                                      </NavItem>
                              </Nav>
                          </div>
                      </Col>
                  </Row>

                  <TabContent className="tab-storelist" activeTab={state.activeTabCount}>
                      <TabPane tabId="1">
                          <div className="known-dev known-develop-tab">
                              <Row className="mb-2 mt-3 pb-1">
                                  <Col md={ isDataAvailable ? "7": "12" }>
                                      <p className="font-sz-13 lne-hgt20 mb-0">
                                          Profile information on every property development in the market. Each development profile includes information such as development Stage, Project Type, Store Name, Owner, Address, etc.
                                      </p>
                                  </Col>
                                  <Col
                        md="5"
                        className="float-right text-right competitor-nav se-competitor-menu project-download-div"
                      >
                        { isDataAvailable  ?
                          <div className="verified-check">
                           <div className="project-label">Project Verification Status :</div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.verifyChecked}
                                    onChange={handleVerifyCheck}
                                    name="verifyChecked"
                                    MuiCheckbox-colorSecondary
                                    className="track-check-gl"
                                  />
                                }
                                label="Verified"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.unVerifyChecked}
                                    onChange={handleVerifyCheck}
                                    name="unVerifyChecked"
                                    MuiCheckbox-colorSecondary
                                    className="track-check-gl"
                                  />
                                }
                                label="Unverified"
                                className="mr-0"
                              />
                        </div>
                        :null}
                        {state.activeTab === "1" &&
                          state.updateDataKD &&
                          state.updateDataKD.pInfo && state.updateDataKD.pInfo.length > 0  &&  
                          state.updateDataKD.oInfo && state.updateDataKD.oInfo.length > 0  && 
                          state.updateDataKD.cInfo && state.updateDataKD.cInfo.length > 0  && 
                          state.updateDataKD.opInfo && state.updateDataKD.opInfo.length > 0 && 
                          state.updateDataKD.dCenter && state.updateDataKD.dCenter.length > 0 ? (
                          <div className='download-all-btn'>
                            <b>Download:</b>
                            <span
                              onClick={() => state?.avoidPdfMultipleCliks && exportCompPDF()}
                              style={{ cursor: "pointer", marginRight: "10px" }}
                              className={state.disablePdf ? 'remove-widgets disabled pdf-down-btn' : 'remove-widgets pdf-down-btn'}
                              data-html2canvas-ignore
                            >
                              <Tooltip title="Download widget" placement="top">
                                <IconButton aria-label="export">
                                  <PictureAsPdfIcon />
                                </IconButton>
                              </Tooltip>
                             
                            </span>
                            <span
                              onClick={() => state?.avoidExcelMultipleCliks && exportCompExcel()}
                              style={{ cursor: "pointer", marginRight: "10px" }}
                              className={state.disablePdf ? 'remove-widgets disabled pdf-down-btn' : 'remove-widgets pdf-down-btn'}
                              data-html2canvas-ignore
                            >
                              <Tooltip title="Download excel" placement="top">
                              <img src={excelicon} alt="excel-icon" />
                              </Tooltip>
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                              </Row>
                              {/* Additional UI rendering based on the state */}
                              <div className="overflow-scroll-table br-0 overflow-scroll-table-kd">
                      <Paper className="bx-sh-0">
                        { state.updateDataKD &&
                                  state.updateDataKD.pInfo && state.updateDataKD.pInfo.length > 0  &&  
                                  state.updateDataKD.oInfo && state.updateDataKD.oInfo.length > 0  && 
                                  state.updateDataKD.cInfo && state.updateDataKD.cInfo.length > 0  && 
                                  state.updateDataKD.opInfo && state.updateDataKD.opInfo.length > 0 && 
                                  state.updateDataKD.dCenter && state.updateDataKD.dCenter.length > 0 ?
                        (state.knownDevTabs.map((data) => (
                          <Accordion
                            expanded={data.isOpen === true}
                            onChange={() => {
                              accordionChange(data.id);
                            }}
                          >
                            <AccordionSummary
                              className="pl-0"
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={data.id}
                              id={data.id}
                            >
                              <h4
                                style={{
                                  display: "inlineBlock",
                                  fontSize: "13px",
                                  color: "#606060",
                                  marginBottom: '0px'
                                }}
                              >
                                {data.name}{" "}
                              </h4>
                            </AccordionSummary>
                            <AccordionDetails>
                              {
                                state.updateDataKD &&
                                state.updateDataKD.pInfo &&
                                state.updateDataKD.pInfo.length > 0 ? (
                                  <div
                                    className={
                                      state.updateDataKD &&
                                      state.updateDataKD.pInfo &&
                                      state.updateDataKD.pInfo.length > 1 &&
                                        data.id === 1
                                        ? "scorallable-table-kd"
                                        : state.updateDataKD &&
                                        state.updateDataKD.oInfo &&
                                        state.updateDataKD.oInfo.length > 1 &&
                                          data.id === 2
                                          ? "scorallable-table-kd"
                                          : state.updateDataKD &&
                                          state.updateDataKD.cInfo &&
                                          state.updateDataKD.cInfo.length > 1 &&
                                            data.id === 3
                                            ? "scorallable-table-kd"
                                            : state.updateDataKD &&
                                            state.updateDataKD.opInfo &&
                                            state.updateDataKD.opInfo.length > 1 &&
                                              data.id === 4
                                              ? "scorallable-table-kd"
                                              :state.updateDataKD &&
                                              state.updateDataKD.dCenter &&
                                              state.updateDataKD.dCenter.length > 0 &&
                                                data.id === 5
                                                ? "scorallable-table-kd"
                                                : "scorallable-table-kd"
                                    }
                                    id={
                                      state.updateDataKD &&
                                      state.updateDataKD.pInfo &&
                                      state.updateDataKD.pInfo.length > 2 &&
                                        data.id === 1
                                        ? "enable-scroll-kd"
                                        : state.updateDataKD &&
                                        state.updateDataKD.oInfo &&
                                        state.updateDataKD.oInfo.length > 2 &&
                                          data.id === 2
                                          ? "enable-scroll-kd"
                                          : state.updateDataKD &&
                                          state.updateDataKD.cInfo &&
                                          state.updateDataKD.cInfo.length > 2 &&
                                            data.id === 3
                                            ? "enable-scroll-kd"
                                            : state.updateDataKD &&
                                            state.updateDataKD.opInfo &&
                                            state.updateDataKD.opInfo.length > 2 &&
                                              data.id === 4
                                              ? "enable-scroll-kd"
                                              : state.updateDataKD &&
                                              state.updateDataKD.dCenter &&
                                              state.updateDataKD.dCenter.length > 2 &&
                                                data.id === 5 &&
                                                state.updateDataKD &&
                                                state.updateDataKD.pInfo &&
                                                state.updateDataKD.pInfo.length > 2
                                                ? "enable-scroll-kd"
                                                : ""
                                    }
                                  >
                                    <table>
                                      {state.updateDataKD &&
                                        state.updateDataKD.pInfo &&
                                        state.updateDataKD.pInfo.length > 0
                                        ? displayPropertyDetail(data.id)
                                        : null}
                                    </table>
                                  </div>
                                ) : (
                                  <p className="no-data">No Data Available</p>
                                )}
                            </AccordionDetails>
                          </Accordion>
                        )))
                        : dataLoader ? "": SpanMessage("developments") }
                      </Paper>
                    </div>
                          </div>
                      </TabPane>

                      <TabPane tabId="2">
                          <Transaction
                              activeTabCount={state.activeTabCount}
                              MarketID={state.MarketID}
                              reportDownloadMsg={(open, msg, clr) => setState(prev => ({ ...prev, snackOpen: open, snackMsg: msg, snackClr: clr }))}
                              marketProps={marketProps}
                          />
                      </TabPane>
                  </TabContent>
              </Col>
          </div>

          <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={state.snackOpen}
              id={state.snackClr}
              className="snack-bar custom-snackbar"
              autoHideDuration={5000}
              onClose={snackHandleClose}
              message={<span>{state.snackMsg}</span>}
              action={[
                  <IconButton
                      key="close"
                      aria-label="Close"
                      color="inherit"
                      onClick={snackHandleClose}
                  >
                      {/* <PictureAsPdfIcon /> */}
                  </IconButton>,
              ]}
          />
      </div>
  );
});

export default KnownDevelopments;